import { render, staticRenderFns } from "./AssessmentGroupStudyUnit.vue?vue&type=template&id=114d63c5&scoped=true"
import script from "./AssessmentGroupStudyUnit.vue?vue&type=script&lang=js"
export * from "./AssessmentGroupStudyUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114d63c5",
  null
  
)

export default component.exports